<template>
  <section class="page-section-fluid">
    <BaseContainer>
      <h3 class="page-section-fluid__heading" v-if="title">
        <TextHeading>{{ title }}</TextHeading>
      </h3>
    </BaseContainer>
    <slot></slot>
  </section>
</template>

<script>
import TextHeading from './TextHeading.vue'
import BaseContainer from './BaseContainer.vue'
export default {
  name: 'PageSectionFluid',
  components: {
    BaseContainer,
    TextHeading
  },
  props: {
    title: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="postcss">
.page-section-fluid {
  @apply mt-8 mb-12;
}
.page-section-fluid__heading {
  @apply mb-3;
}
.page.modal .page-section-fluid {
  @apply mt-0;
}
@screen lg {
  .page-section-fluid {
    @apply mt-16 mb-24;
  }
  .page-section-fluid__heading {
    @apply mb-6;
  }
}
</style>

